// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26_U8","delete":"styles_delete__4nOPC","update":"styles_update__OYhAN","add":"styles_add__2ujEu"};